import type { Quote } from '@/types';

export const quotes: Quote[] = [
  {
    id: 'VP-2026-0048',
    customerName: 'Ayşe Yılmaz',
    service: 'Villa Detaylı Temizlik',
    location: 'Beykoz / İstanbul',
    date: '28 Ağustos 2026',
    amount: 18500,
    status: 'Onaylandı',
    revision: 1,
    scope: '2 katlı villa detaylı temizlik, camlar, zemin cilası ve mutfak-banyo derin temizliği.',
    operationalNote: 'A Ekibi görevlendirildi. Sabah 10:00 giriş.',
    customerNote: 'Tüm katlar ve camlar dahil olacak şekilde kapsamlı temizlik.',
  },
  {
    id: 'VP-2026-0047',
    customerName: 'Selin Kaya',
    service: 'Residence Temizliği',
    location: 'Ataşehir / İstanbul',
    date: '26 Ağustos 2026',
    amount: 12000,
    status: 'Cevap Bekleniyor',
    revision: 1,
    scope: '3+1 rezidans detaylı temizlik, eşyalı daire.',
    operationalNote: 'Teklif gönderildi, 2 gündür cevap bekleniyor.',
    customerNote: 'Taşınmadan önce detaylı temizlik.',
  },
  {
    id: 'VP-2026-0046',
    customerName: 'Elif Doğan',
    service: 'Villa Temizliği',
    location: 'Üsküdar / İstanbul',
    date: '29 Ağustos 2026',
    amount: 15000,
    status: 'Müşteriye Gönderildi',
    revision: 1,
    scope: 'Villa dönemsel derin temizlik.',
    operationalNote: 'Düzenli müşteri, öncelikli.',
    customerNote: 'Düzenli periyodik temizlik.',
  },
  {
    id: 'VP-2026-0045',
    customerName: 'Murat Öztürk',
    service: 'Koltuk Yıkama',
    location: 'Çankaya / Ankara',
    date: '30 Ağustos 2026',
    amount: 7800,
    status: 'Taslak',
    revision: 1,
    scope: '3+2 koltuk takımı yıkama.',
    operationalNote: 'Değerlendirme tamamlandı, tutar taslağı.',
    customerNote: 'Koltuk takımı yıkama.',
  },
  {
    id: 'VP-2026-0044',
    customerName: 'Fatma Şahin',
    service: 'Yazlık Ev Temizliği',
    location: 'Büyükçekmece / İstanbul',
    date: '27 Ağustos 2026',
    amount: 9600,
    status: 'Revize İstendi',
    revision: 2,
    scope: 'Yazlık açılış temizliği.',
    operationalNote: 'Müşteri revizyon istedi, alan güncellendi.',
    customerNote: 'Ek olarak teras temizliği eklensin.',
  },
];